export function rangeIso(days: number): { from: string; to: string } {
  const to = new Date();
  const from = new Date(to.getTime() - days * 24 * 60 * 60 * 1000);
  return { from: from.toISOString(), to: to.toISOString() };
}

export function formatTokens(n?: number | null): string {
  if (n == null) return '—';
  if (n >= 1_000_000) return `${(n / 1_000_000).toFixed(1)}M`;
  if (n >= 1_000) return `${(n / 1_000).toFixed(1)}K`;
  return String(n);
}

/** Short session id for tables: first 8 chars + ellipsis (full id via title). */
export function formatSessionId(sessionId?: string | null): string {
  if (!sessionId) return '—';
  const compact = sessionId.replace(/-/g, '');
  if (compact.length <= 8) return sessionId;
  return `${compact.slice(0, 8)}…`;
}

export function formatPct(n?: number | null): string | null {
  if (n == null) return null;
  const sign = n > 0 ? '+' : '';
  return `${sign}${n}%`;
}

export function isCostQuery(text: string): boolean {
  const lower = text.toLowerCase();
  return (
    lower.includes('cost') ||
    lower.includes('invoice') ||
    lower.includes('charge') ||
    lower.includes('spend') ||
    lower.includes('$')
  );
}

/**
 * Human-readable chart axis / tooltip label for timeseries buckets.
 * Accepts ISO (`2026-07-25T00:00:00Z`) and Postgres-style (`2026-07-25 00:00:00+00:00`).
 * Always formats in UTC to match Staff/Analytics period labels.
 */
export function formatChartBucket(
  bucket: string | null | undefined,
  grain: string = 'day',
): string {
  if (!bucket) return '—';
  const normalized = bucket.includes('T') ? bucket : bucket.replace(' ', 'T');
  const d = new Date(normalized);
  if (Number.isNaN(d.getTime())) {
    const dateOnly = bucket.slice(0, 10);
    return /^\d{4}-\d{2}-\d{2}$/.test(dateOnly) ? dateOnly : bucket;
  }
  const utc: Intl.DateTimeFormatOptions = { timeZone: 'UTC' };
  switch (grain) {
    case 'hour':
      return d.toLocaleString('en-GB', {
        ...utc,
        day: 'numeric',
        month: 'short',
        hour: '2-digit',
        minute: '2-digit',
        hour12: false,
      });
    case 'month':
      return d.toLocaleString('en-GB', {
        ...utc,
        month: 'short',
        year: 'numeric',
      });
    case 'year':
      return d.toLocaleString('en-GB', { ...utc, year: 'numeric' });
    case 'week':
    case 'day':
    default:
      return d.toLocaleString('en-GB', {
        ...utc,
        day: 'numeric',
        month: 'short',
      });
  }
}
